import { Factory } from 'fishery'
import { v4 as uuidV4 } from 'uuid'
import { OpalApiComponent } from '@opallabs/api'
import { EMPTY_TO_ONE, linkageFromResource } from '@opallabs/json-api'
import { userResourceFactory } from './user'

type UserProfileResourceV3 = OpalApiComponent<'V3', 'user_profile'>

export const userProfileResourceFactory: Factory<UserProfileResourceV3> =
  Factory.define<UserProfileResourceV3>(({ afterBuild, params, sequence }) => {
    afterBuild((userProfile) => {
      /**
       * The `user` resource circularly depends on this `user_profile` existing. To work around this, we will
       * stub a fake user originally, then create and set an actual `user` resource once the profile has
       * been built and can be used.
       *
       * This won't run if a user relationship is created beforehand and passed in as a parameter
       */
      if (!params.relationships?.user) {
        const user = userResourceFactory.build({
          relationships: { profile: linkageFromResource(userProfile) },
        })
        userProfile.relationships.user = linkageFromResource(user)
      }
    })

    return {
      id: uuidV4(),
      type: 'user_profile',
      attributes: {
        bio: null,
        created_at: new Date().toISOString(),
        job_title: null,
        legacy_id: `${sequence}`,
        location: null,
        segments: null,
        updated_at: new Date().toISOString(),
      },

      relationships: {
        avatar_asset_reference: EMPTY_TO_ONE,
        user: { data: { id: 'stubbed_until_afterBuild', type: 'user' } },
      },
    }
  })
